
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 11","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.727 3.973c-.63.492-1.422 1.093-4.211 3.117C8.969 7.5 7.957 8.402 7 8.402c-.984 0-1.969-.902-2.543-1.312C1.668 5.066.875 4.465.247 3.973c-.11-.082-.247 0-.247.136v5.579C0 10.425.574 11 1.313 11h11.374C13.399 11 14 10.426 14 9.687V4.11c0-.136-.164-.218-.273-.136zM7 7.5c.629.027 1.531-.793 1.996-1.121 3.637-2.625 3.91-2.871 4.73-3.527a.622.622 0 00.274-.52v-.52A1.33 1.33 0 0012.687.5H1.313C.574.5 0 1.102 0 1.813v.519c0 .219.082.41.246.52.82.656 1.094.902 4.73 3.527C5.442 6.707 6.345 7.527 7 7.5z"}})])
          )
        }
      }
    